

export interface IListInvoicesResult {
    items: IInvoice[]
    totalPages: number
    totalCount: number
}

export const InvoiceTypes = {
    fuel: "fuel",
    aviabooking: "aviabooking",
    discounts: "discounts",
    foodService: "food_service"
} as const

export type InvoiceType = typeof InvoiceTypes[keyof typeof InvoiceTypes]

export const InvoiceStatuses = {
    canceled: "canceled",
    pending: "pending",
    approved: "approved",
    rejected: "rejected"
} as const

export type InvoiceStatus = typeof InvoiceStatuses[keyof typeof InvoiceStatuses]

export interface IInvoice {
    type: InvoiceType
    status: InvoiceStatus
    id: number
    amount: number
    created_at: string
    document_number: string
}

export interface ICreateInvoiceRequest {
    amount: number
    type: InvoiceType
}